import { useState, useEffect } from 'react';
import Order from 'communication/types/order/Order';
import { useOrdersStateSelector } from 'app/store/orders/selectors';
import { toOrderResults, NoStateTicks } from './selectors';
import {
    useSelectBlotterFilteredOrdersResults,
    useSelectBlotterFilteredOrdersResultsTicks,
} from './selectors';
import { useSelectActiveInput } from 'portfolio/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

const EmptyOrders: Order[] = [];

export const useBlotterFilteredOrders = (widgetKey: string) => {
    const [results, setResults] = useState<Order[]>([]);

    const ticks = useSelectBlotterFilteredOrdersResultsTicks(widgetKey);
    const filterResults = useSelectBlotterFilteredOrdersResults(widgetKey);
    const { data: orders } = useOrdersStateSelector();

    useEffect(() => {
        if (ticks === NoStateTicks) {
            setResults(EmptyOrders);
            return;
        }
        const results = toOrderResults(orders, filterResults);
        setResults(results);
        // Filter results always follow an orders update, and ticks are always set when filtered results or update,
        // so all we need to be dependent on is ticks (and the widgetKey)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [widgetKey, ticks]);

    return results;
};

export const useActiveBlotterFilteredOrders = () => {
    const activeInput = useSelectActiveInput();
    const activeBlotterWidgetKey =
        activeInput.activeInputType === 'Widget' &&
        activeInput.activeInputWidget!.type === WidgetType.BLOTTER
            ? activeInput.activeInputWidget!.id
            : undefined;

    return useBlotterFilteredOrders(activeBlotterWidgetKey ?? '');
};
